import TimeIcon from '../../images/zegar.svg';
import useTimerHook from './hooks/useTimerHook';
import { TextTimer, TimerWrapper } from './timer.styles';

const Timer = ({ promo }) => {
	const time = useTimerHook();

	return (
		<TimerWrapper
			style={{ border: `3px solid ${promo ? '#0FA831' : '#FF4B55'}` }}
		>
			<div>{time}</div>
			<img src={TimeIcon} />
			<TextTimer>Oferta por tempo limitado</TextTimer>
		</TimerWrapper>
	);
};

export default Timer;
